import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { loginAs } from '../../Admins/actionsSagas';
import {
  authyVerificationRequest,
  resendCodeRequest,
  resetStatus,
} from '../../Login/actions';
import { resetErrors } from '../actions';
import { resetPasswordForgotActionSagas } from '../actionsSagas';
import ResetPasswordStateful from './ResetPasswordStateful';

const mapStateToProps = (state) => ({
  resetRequest: state.resetPassword,
});

const mapDispatchToProps = (dispatch) => ({
  resetPasswordForgotRequest: (payload) => {
    dispatch(resetPasswordForgotActionSagas(payload));
  },
  resetErrors: () => {
    dispatch(resetErrors());
  },
  loginAs: (admin) => {
    dispatch(loginAs(admin));
  },
  authyVerificationRequest: (code, email) => {
    dispatch(authyVerificationRequest(code, email));
  },
  resendCodeRequest: (email) => {
    dispatch(resendCodeRequest(email));
  },
  resetStatus: () => {
    dispatch(resetStatus());
  },
});

const connected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ResetPasswordStateful);

// in our Redux's state, this form will be available in 'form.login'
const ResetPasswordContainer = reduxForm({
  form: 'ResetPassword',
})(connected);

export default ResetPasswordContainer;
